import React from "react";
import { useNavigate } from "react-router-dom";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { TableReportesUsabilidad } from "../components/TableReporteUsabilidad";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";
import "../theme/ReporteCierreDia.css";
import { useDynamicAuth } from "../context/AuthProviderContext"; // Importar el hook

/** Reporte de usabilidad */
export const ReporteUsabilidadPage = () => {
  const navigate = useNavigate();
  const authProvider = useDynamicAuth(); // Usar el hook

  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div>
              <div className="title-name-admin">
                <div className="icon-goback-title-admin">
                  <BtnGoBack caption="Volver a reportes" />
                </div>
              </div>
              <div className="box-table-contantent-reportes">
                <TableReportesUsabilidad />
              </div>
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
